import { createContext } from 'react'

import { DIALOG_TYPE } from '@/dialogs/constants'

import {
  BLACK_FRIDAY_CAMPAIGN_END,
  BLACK_FRIDAY_DISCOUNT,
} from '../black-friday/consts'
import {
  CHRISTMAS2025_CAMPAIGN_END,
  CHRISTMAS_CAMPAIGN_END,
  CHRISTMAS_DISCOUNT,
} from '../christmas/consts'
import type { CampaignsContextValue } from './types'
import { Campaigns } from './types'

export const SEEN_PROMOTION_DIALOGS_STORAGE_KEY = 'seen-promotion-dialogs'
export const CampaignsContext = createContext<CampaignsContextValue | null>(
  null,
)

export const promotionDialogsMap = {
  [Campaigns.BlackFriday]: DIALOG_TYPE.BLACK_FRIDAY_PROMOTION,
  [Campaigns.Christmas]: DIALOG_TYPE.CHRISTMAS_PROMOTION,
  [Campaigns.Christmas2025]: DIALOG_TYPE.CHRISTMAS_2025_PROMOTION,
} as const

export const discountsMap: Record<Campaigns, number> = {
  [Campaigns.BlackFriday]: BLACK_FRIDAY_DISCOUNT,
  [Campaigns.Christmas]: CHRISTMAS_DISCOUNT,
  [Campaigns.Christmas2025]: 0,
}

export const campaignEndDatesMap: Record<Campaigns, number> = {
  [Campaigns.BlackFriday]: BLACK_FRIDAY_CAMPAIGN_END,
  [Campaigns.Christmas]: CHRISTMAS_CAMPAIGN_END,
  [Campaigns.Christmas2025]: CHRISTMAS2025_CAMPAIGN_END,
}
